/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: { animationPaddingBottomAfter: 8, animationPaddingTopAfter: 8 }
    }
  ],
  tokens: {
    animationBackgroundColorAfter: '#fcf8ee',
    animationBackgroundColorBefore: '#394056',
    animationColorAfter: '#394056',
    animationColorBefore: '#fefefc',
    animationDivColorAfter: '#636c8c',
    animationDivColorBefore: '#f9f2dd',
    animationHeightAfter: 24,
    animationHeightBefore: 0,
    animationPaddingBottomAfter: 16,
    animationPaddingBottomBefore: 0,
    animationPaddingTopAfter: 16,
    animationPaddingTopBefore: 0,
    chevronlinkFontName: 'SofiaPro',
    chevronlinkFontWeight: '400',
    containerBackgroundColor: '#394056',
    containerGap: 12,
    padding: 16
  }
}
export default theme
